<mat-slider fxFlex color="accent" step="1" min="0" [max]="options.length - 1" showTickMarks>
  <input [value]="sliderValue" (valueChange)="onSliderChange($event)" matSliderThumb />
</mat-slider>
